import { TimeOptionsSchema } from "@/packages/shared/src/models/scheduling-availability";
import { Appointment, AppointmentType } from "@/src/models/appointment";
import {
  AppointmentSlot,
  type SchedulingLocationSummary,
  schedulingLocationSummariesSchema,
} from "@/src/models/comms/scheduling-schemas";
import { Practitioner } from "@/src/models/practitioner";
import { type SchedulingCapabilities, schedulingCapabilitiesSchema } from "@/src/models/scheduling-capabilities";
import { fetchJSON } from "@/src/requests/utils/fetch-json";

export async function getPatientAppointments(patientId: string): Promise<Appointment[]> {
  return fetchJSON<Appointment[]>(`/api/scheduling/appointments/${patientId}`);
}

export interface IsEstablishedPatientResponse {
  isEstablishedPatient: boolean;
}

export async function isEstablishedPatient(patientId: string): Promise<IsEstablishedPatientResponse> {
  return fetchJSON<IsEstablishedPatientResponse>(`/api/scheduling/patients/${patientId}/established`);
}

export async function getPractitioners(patientId: string): Promise<Practitioner[]> {
  return fetchJSON<Practitioner[]>(`/api/scheduling/practitioners/${patientId}`);
}

export async function getLocations(patientId: string): Promise<SchedulingLocationSummary[]> {
  const url = `/api/scheduling/locations?patientId=${encodeURIComponent(patientId)}`;
  const response = await fetchJSON<object>(url);

  return schedulingLocationSummariesSchema.parse(response);
}

export async function getSchedulingCapabilities(): Promise<SchedulingCapabilities> {
  const response = await fetchJSON<Record<string, unknown>>("/api/scheduling/capabilities");

  return schedulingCapabilitiesSchema.parse(response);
}

export async function checkAvailability(
  patientId: string,
  appointmentType: AppointmentType,
  practitionerIds: string[],
  locationIds: string[],
  scheduleAvailability: TimeOptionsSchema
): Promise<AppointmentSlot[]> {
  return fetchJSON<AppointmentSlot[]>(`/api/scheduling/appointments/availability`, {
    method: "POST",
    body: JSON.stringify({
      patientId,
      practitionerIds,
      locationIds,
      appointmentType,
      scheduleAvailability,
    }),
  });
}
